import { IShippingInfo } from '../types';
import './style.scss';
import { dateFormatter } from '@global/utils/date';
import { LOCALE_CODES } from '@global/types/types';
import { CountryService } from '@global/utils/CountryService';
import { store } from '@global/store/store';
import { RootState } from '@global/store/store';

interface ShippingInfoSummaryProps {
  shippingInfo: IShippingInfo;
  locale: LOCALE_CODES;
}

export const ShippingSummary = ({
  shippingInfo,
  locale,
}: ShippingInfoSummaryProps) => {
  const { country: countryState } = store.getState() as RootState;

  if (!shippingInfo?.addressOne) return null;
  const {
    firstName,
    lastName,
    phone,
    zip,
    country,
    state,
    city,
    addressOne,
    addressTwo,
    email,
    deliveryInfo,
  } = shippingInfo;

  const countryObj = country?.iso2Code
    ? CountryService.getCountryByIsoCode(
        countryState.countries,
        country.iso2Code
      )
    : undefined;

  const displayState =
    countryObj && state
      ? CountryService.convertChinaStateCodeForDisplay(countryObj, state)
      : state;

  function getDate(date: string) {
    return dateFormatter(date, locale, {
      month: 'long',
      day: 'numeric',
    });
  }

  // Example: "Standard Shipping - $1.00 (Arrives December 28 - January 02)"
  const delivery = deliveryInfo
    ? `${deliveryInfo.title} - ${deliveryInfo.price} (Arrives ${getDate(
        deliveryInfo.date.to
      )})`
    : null;

  return (
    <div className="shipping-summary">
      <p>
        {firstName} {lastName}
      </p>
      <p>{addressOne}</p>
      {addressTwo ? <p>{addressTwo}</p> : null}
      <p>
        {city}, {displayState} {zip}
      </p>
      <p>{country.name}</p>
      <p>{phone}</p>
      {email ? <p>{email}</p> : null}
      {delivery ? <p>{delivery}</p> : null}
    </div>
  );
};
